import React, { Component } from 'react';
import classNames from 'classnames';

import Ribbon from './Ribbon';

export class Box extends Component {
  boxClasses() {
    return classNames('box', {
      'hidden-xs': this.props.empty || this.props.disabled,
      'hidden-sm': this.props.empty || this.props.disabled
    });
  }

  contentClasses() {
    return classNames('box__content', {
      empty: this.props.empty,
      disabled: this.props.disabled
    });
  }

  renderInner() {
    return <div className="title">{this.props.title}</div>;
  }

  renderRibbon() {
    if (!this.props.ribbonHref && !this.props.ribbonLabel) {
      return null;
    }

    return (
      <Ribbon
        position={this.props.ribbonPosition}
        color={this.props.ribbonColor}
        href={this.props.ribbonHref}
        label={this.props.ribbonLabel}
      />
    );
  }

  render() {
    let link = this.props.link;

    if (!link && this.props.id) {
      link = `/${this.props.id}`;
    }

    if (!link) {
      return (
        <div className={this.boxClasses()}>
          {this.renderRibbon()}
          <div className={this.contentClasses()} id={this.props.id}>
            {this.renderInner()}
          </div>
        </div>
      );
    }

    return (
      <div className={this.boxClasses()}>
        {this.renderRibbon()}
        <a href={link} className={this.contentClasses()} id={this.props.id}>
          {this.renderInner()}
        </a>
      </div>
    );
  }
}

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box.js